'use client';
export { Wrap, WrapItem } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map